/* global globalThis */

const GTM_ID_PATTERN = /^GTM-[A-Z0-9]+$/;

export function initGTM(gtmId) {
  if (!gtmId || typeof document === 'undefined' || !GTM_ID_PATTERN.test(gtmId)) {
    return;
  }

  globalThis.dataLayer = globalThis.dataLayer || [];

  const scriptContent = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${gtmId}');`;

  const script = document.createElement('script');
  script.id = 'gtag-base';
  script.text = scriptContent;
  document.head.appendChild(script);
}
